'use client';

import { useEffect, useState } from 'react';
import StoreItem from './StoreItem';
import { Store } from './types';

interface Props {
  onStoreSelect: (store: Store | null) => void;
  stores: Store[];
}

const StoresList = ({ onStoreSelect, stores }: Props) => {
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);

  useEffect(() => {
    onStoreSelect(selectedStore);
  }, [onStoreSelect, selectedStore]);

  return stores.map((x) => <StoreItem key={x.id} store={x} onClick={setSelectedStore} />);
};

export default StoresList;
